import $, { extend } from 'jquery';
import React,{useEffect,useContext,useState} from 'react';
// import {GbSetGetPartyInfo,GbSetGetItemInfo,
//   GbSetSiteMaster,GbSetVehicleMaster} from '../cGlobal/cls_global';
import { GlobalContext } from '../context';
import {CallMapMethod_CBack,getAppUrl} from '../function_lib/common_lib';
import Select from 'react-select';
import axios from 'axios';
//import './comp_auto_complete.css';


export function CompGetAcademicProgram(props){
  const {gbStAcademicProg,setGbAcademicProgram}=useContext(GlobalContext);
  const [selectedOption, setSelectedOption] = useState(null);
  const handleChange = (option) => {
    setSelectedOption(option);
    if(typeof props.onChangeBack!=="undefined"){
      props.onChangeBack(option);
    }
  };
  useEffect(() => {
        
    // This code will run after the component has mounted
//alert("hello"+gbStPartyInfo+"noon");   
const fetchData = async () => {
  //alert(props.setData);
if((gbStAcademicProg.length===0)){

//alert("i m in sync");
//   const map = {
//     curl_type: "getMachineUsers",
//     res_func: "callBackrrr",
//     gb_token: props.userObject[0].app_user_id
//   };
const map = new FormData();
map.append("curl_type", "getAcademicProgram");
map.append("res_func", "callBackrrr");
map.append("local_token", props.userObject[0].app_user_id);
map.append("user_type",props.userObject[0].type);
map.append("type_master_id","2");
map.append("access_type",props.userObject[0].access_type);
map.append("upper_id",props.userObject[0].upper_id);

const apiUrl = getAppUrl()+"getAcademicProgram";
//  alert(apiUrl);
const response = await axios.post(apiUrl, map);
//  alert(response.data);
var checkData=$($($.parseHTML(response.data)).filter("#resP")).text();
var checkMsg=$($($.parseHTML(response.data)).filter("#resPS")).text();
if(checkData!=="0"){
  // alert(checkData);
  let compMasterData=JSON.parse(checkData);
  //ExtCompAutoComplete(props,compMasterData["party_info"]);
  setGbAcademicProgram(compMasterData);
}
}else{
//ExtCompAutoComplete(props,gbStPartyInfo);
}


}
    
    fetchData();
    
    
    // You can return a cleanup function if needed
    return () => {
      // This code will run when the component unmounts
      //console.log('Component unmounted');
    };
  }, [props.autoList]); // Pass an empty array as the second argument to run the effect only once after mounting
if (props.setData!==true){
  return(<select id={props.comp_id} name={props.comp_name} placeholder={props.placeHolder} className={props.propClass}>
       <option value={"0"}>-Select-</option>
       {gbStAcademicProg.map((item,index)=>{
        return <option value={item["id"]}>{item["academic_program"]}</option>
       })}
  </select>)
}else{
  return(<></>)
}

}

export function CompGetCurriculum(props){

  const {gbStCurriculum,setGbCurriculum}=useContext(GlobalContext);
  const [selectedOption, setSelectedOption] = useState(null);
  const handleChange = (option) => {
    setSelectedOption(option);
    if(typeof props.onChangeBack!=="undefined"){
      props.onChangeBack(option);
    }
  };
  useEffect(() => {
        
    // This code will run after the component has mounted
//alert("hello"+gbStPartyInfo+"noon");   
const fetchData = async () => {
  //alert(props.setData);
if((gbStCurriculum.length===0)){

//alert("i m in sync");
//   const map = {
//     curl_type: "getMachineUsers",
//     res_func: "callBackrrr",
//     gb_token: props.userObject[0].app_user_id
//   };
const map = new FormData();
map.append("curl_type", "getCurriculam");
map.append("res_func", "callBackrrr");
map.append("local_token", props.userObject[0].app_user_id);
map.append("user_type",props.userObject[0].type);
map.append("type_master_id","2");
map.append("access_type",props.userObject[0].access_type);
map.append("upper_id",props.userObject[0].upper_id);

const apiUrl = getAppUrl()+"getCurriculam";
// alert(apiUrl);
const response = await axios.post(apiUrl, map);
// alert(response.data);
var checkData=$($($.parseHTML(response.data)).filter("#resP")).text();
var checkMsg=$($($.parseHTML(response.data)).filter("#resPS")).text();
if(checkData!=="0"){
  let compMasterData=JSON.parse(checkData);
  //ExtCompAutoComplete(props,compMasterData["party_info"]);
  setGbCurriculum(compMasterData);
}
}else{
//ExtCompAutoComplete(props,gbStPartyInfo);
}


}
    
    fetchData();
    
    
    // You can return a cleanup function if needed
    return () => {
      // This code will run when the component unmounts
      //console.log('Component unmounted');
    };
  }, [props.autoList]); // Pass an empty array as the second argument to run the effect only once after mounting
if (props.setData!==true){
  return(<select id={props.comp_id} name={props.comp_name} placeholder={props.placeHolder} className={props.propClass}>
       <option value={"0"}>-Select-</option>
       {gbStCurriculum.map((item,index)=>{
        return <option value={item["id"]}>{item["curri_name"]}</option>
       })}
  </select>)
}else{
  return(<></>)
}


}

export function CompGetAcademicYear(props){
  const {gbStSessionYear,setGbSessionYear}=useContext(GlobalContext);
  const [selectedOption, setSelectedOption] = useState(null);
  const handleChange = (option) => {
    setSelectedOption(option);
    if(typeof props.onChangeBack!=="undefined"){
      props.onChangeBack(option);
    }
    //alert(JSON.stringify(option));
    //onChange(option);
  };
  useEffect(() => {
        
    // This code will run after the component has mounted
//alert("hello"+gbStPartyInfo+"noon");   
const fetchData = async () => {
  //alert(props.setData);
if((gbStSessionYear.length===0)){

//alert("i m in sync");
//   const map = {
//     curl_type: "getMachineUsers",
//     res_func: "callBackrrr",
//     gb_token: props.userObject[0].app_user_id
//   };
const map = new FormData();
map.append("curl_type", "getSessionYear");
map.append("res_func", "callBackrrr");
map.append("local_token", props.userObject[0].app_user_id);
map.append("user_type",props.userObject[0].type);
map.append("type_master_id","2");
map.append("access_type",props.userObject[0].access_type);
map.append("upper_id",props.userObject[0].upper_id);

const apiUrl = getAppUrl()+"getSessionYear";
// alert(apiUrl);
const response = await axios.post(apiUrl, map);
// alert(response.data);
var checkData=$($($.parseHTML(response.data)).filter("#resP")).text();
var checkMsg=$($($.parseHTML(response.data)).filter("#resPS")).text();
if(checkData!=="0"){
  let compMasterData=JSON.parse(checkData);
  //ExtCompAutoComplete(props,compMasterData["party_info"]);
  setGbSessionYear(compMasterData);
}
}else{
//ExtCompAutoComplete(props,gbStPartyInfo);
}


}
    
    fetchData();
    
    
    // You can return a cleanup function if needed
    return () => {
      // This code will run when the component unmounts
      //console.log('Component unmounted');
    };
  }, [props.autoList]); // Pass an empty array as the second argument to run the effect only once after mounting
if (props.setData!==true){
  return(<select id={props.comp_id} name={props.comp_name} placeholder={props.placeHolder} className={props.propClass}>
       <option value={"0"}>-Select-</option>
       {gbStSessionYear.map((item,index)=>{
        return <option value={item["id"]}>{item["session_name"]}</option>
       })}
  </select>)
}else{
  return(<></>)
}

}

export function CompGetAdmins(props){
  const {gbStAdmins, setAdminsMaster} =useContext(GlobalContext);
  const [selectedOption, setSelectedOption] = useState(null);
  const handleChange = (option) => {
    setSelectedOption(option);
    if(typeof props.onChangeBack!=="undefined"){
      props.onChangeBack(option);
    }
    //alert(JSON.stringify(option));
    //onChange(option);
  };

  useEffect(() => {
        
    // This code will run after the component has mounted
//alert("hello"+gbStPartyInfo+"noon");   
const fetchData = async () => {
  //alert(props.setData);
if((gbStAdmins.length===0)){

//alert("i m in sync");
//   const map = {
//     curl_type: "getMachineUsers",
//     res_func: "callBackrrr",
//     gb_token: props.userObject[0].app_user_id
//   };
const map = new FormData();
map.append("curl_type", "get_user_info");
map.append("res_func", "callBackrrr");
map.append("local_token", props.userObject[0].app_user_id);
map.append("user_type",props.userObject[0].type);
map.append("type_master_id","2");
map.append("access_type",props.userObject[0].access_type);
map.append("upper_id",props.userObject[0].upper_id);

const apiUrl = getAppUrl()+"get_user_info";
//alert(apiUrl);
const response = await axios.post(apiUrl, map);
//alert(response.data);
var checkData=$($($.parseHTML(response.data)).filter("#resP")).text();
var checkMsg=$($($.parseHTML(response.data)).filter("#resPS")).text();
if(checkData!=="0"){
  let compMasterData=JSON.parse(checkData);
  //ExtCompAutoComplete(props,compMasterData["party_info"]);
  setAdminsMaster(compMasterData);
}
}else{
//ExtCompAutoComplete(props,gbStPartyInfo);
}


}
    
    fetchData();
    
    
    // You can return a cleanup function if needed
    return () => {
      // This code will run when the component unmounts
      //console.log('Component unmounted');
    };
  }, [props.autoList]); // Pass an empty array as the second argument to run the effect only once after mounting
if (props.setData!==true){
  return(<select id={props.comp_id} name={props.comp_name} placeholder={props.placeHolder} className={props.propClass}>
       <option value={"0"}>-Select-</option>
       {gbStAdmins.map((item,index)=>{
        return <option value={item["id"]}>{item["entity_code"]}</option>
       })}
  </select>)
}else{
  return(<></>)
}

}



export function CompGetAdmins_AutoComplete(props){
  const {gbStAdmins, setAdminsMaster} =useContext(GlobalContext);
  const [selectedOption, setSelectedOption] = useState(null);
  const handleChange = (option) => {
    setSelectedOption(option);
    if(typeof props.onChangeBack!=="undefined"){
      props.onChangeBack(option);
    }
    //alert(JSON.stringify(option));
    //onChange(option);
  };

  useEffect(() => {
        
    // This code will run after the component has mounted
//alert("hello"+gbStPartyInfo+"noon");   
const fetchData = async () => {
  //alert(props.setData);
if((gbStAdmins===0 || gbStAdmins===null)){

//alert("i m in sync");
//   const map = {
//     curl_type: "getMachineUsers",
//     res_func: "callBackrrr",
//     gb_token: props.userObject[0].app_user_id
//   };
const map = new FormData();
map.append("curl_type", "get_user_info");
map.append("res_func", "callBackrrr");
map.append("local_token", props.userObject[0].app_user_id);
map.append("user_type",props.userObject[0].type);
map.append("type_master_id","2");
map.append("access_type",props.userObject[0].access_type);
map.append("upper_id",props.userObject[0].upper_id);

const apiUrl = getAppUrl()+"get_user_info";
//alert(apiUrl);
const response = await axios.post(apiUrl, map);
//alert(response.data);
var checkData=$($($.parseHTML(response.data)).filter("#resP")).text();
var checkMsg=$($($.parseHTML(response.data)).filter("#resPS")).text();
if(checkData!=="0"){
  let compMasterData=JSON.parse(checkData);
  //ExtCompAutoComplete(props,compMasterData["party_info"]);
  setAdminsMaster(compMasterData);
}
}else{
//ExtCompAutoComplete(props,gbStPartyInfo);
}


}
    
    fetchData();
    
    
    // You can return a cleanup function if needed
    return () => {
      // This code will run when the component unmounts
      //console.log('Component unmounted');
    };
  }, [props.autoList]); // Pass an empty array as the second argument to run the effect only once after mounting
if (props.setData!==true){
  return(<><Select 
    //inputId={props.target_obj}
     id={props.comp_id}
     name={props.comp_name}
    target_obj={props.target_obj}
    value={selectedOption}
    onChange={handleChange}
    options={gbStAdmins}
    getOptionLabel={(option) => option.entity_code}
    getOptionValue={(option) => btoa(option.id)}
    placeholder={props.placeHolder}
    isClearable
  />
  <input className={props.propClass} type="hidden" name={props.target_obj} id={props.target_obj} 
  value={selectedOption ? btoa(selectedOption.value) : ''}
  />
  {typeof  props.comp_sel_text!=="undefined"?<input className={props.propClass} type="hidden" name={props.comp_sel_text} id={props.comp_sel_text}
value={selectedOption?selectedOption.label:''}
 />:''}
  </>)
}else{
  return(<></>)
}

}

// BooksCategoriesAutoComplete
export function CompBooksCategories_AutoComplete(props){
  const {gbStBooksCategories,setGbStBooksCategories} =useContext(GlobalContext);
  const [selectedOption, setSelectedOption] = useState(null);
  const [stCustomeCategory,setCustomeCategory]=useState([]);
  const handleChange = (option) => {
    setSelectedOption(option);
    //alert(JSON.stringify(option));
    if(typeof props.onChangeBack!=="undefined"){
      props.onChangeBack(option);
    }
    //alert(JSON.stringify(option));
    //onChange(option);
  };

  useEffect(() => {
//alert(props.propSelected);
       
// This code will run after the component has mounted
//alert("hello"+gbStPartyInfo+"noon");   
const fetchData = async () => {
  //alert(props.setData);
if((gbStBooksCategories.length===0)){

//alert("i m in sync");
//   const map = {
//     curl_type: "getMachineUsers",
//     res_func: "callBackrrr",
//     gb_token: props.userObject[0].app_user_id
//   };
const map = new FormData();
map.append("curl_type", "getCategoryForSearch");
map.append("res_func", "callBackrrr");
map.append("local_token", props.userObject[0].app_user_id);
map.append("user_type",props.userObject[0].type);
map.append("type_master_id","2");
map.append("access_type",props.userObject[0].access_type);
map.append("upper_id",props.userObject[0].upper_id);

const apiUrl = getAppUrl()+"getCategoryForSearch";
//alert(apiUrl);
const response = await axios.post(apiUrl, map);
//alert(response.data);
var checkData=$($($.parseHTML(response.data)).filter("#resP")).text();
var checkMsg=$($($.parseHTML(response.data)).filter("#resPS")).text();
if(checkData!=="0"){
  //alert(checkData);
  let compMasterData=JSON.parse(checkData);
  //ExtCompAutoComplete(props,compMasterData["party_info"]);
  setGbStBooksCategories(compMasterData);
}
}else{
//ExtCompAutoComplete(props,gbStPartyInfo);
}


}
if(gbStBooksCategories.length>0){
  if(props.topId!==undefined){
    const listFltr=d=>d.top_id===props.topId;
    setCustomeCategory(gbStBooksCategories);
   // setCustomeCategory(gbStBooksCategories.filter(listFltr));
  }else{
    setCustomeCategory(gbStBooksCategories);
  }

  if(typeof props.propSelected!=="undefined"){
    //alert("i m in selected iption");
    //alert(props.propSelected)
    //const listFltrTmp=d=>===props.topId;
    let tmpSelected=gbStBooksCategories.filter(opt=>opt.id.toString()===props.propSelected.toString())
    //alert(JSON.stringify(tmpSelected[0]));
    if(tmpSelected.length===1){
      setSelectedOption(tmpSelected[0]);
    }
    
  } 
}



    
    fetchData();
    
    
    // You can return a cleanup function if needed
    return () => {
      // This code will run when the component unmounts
      //console.log('Component unmounted');
    };

    

  }, [gbStBooksCategories,stCustomeCategory,props.propSelected]); // Pass an empty array as the second argument to run the effect only once after mounting
if (props.setData!==true){
  
const customStyles = {
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    position: 'absolute',
  }),
};
  return(<><Select 
    //inputId={props.target_obj}
     id={props.comp_id}
     name={props.comp_name}
    target_obj={props.target_obj}
    value={selectedOption}
    onChange={handleChange}
    options={stCustomeCategory}
    getOptionLabel={(option) => option.top_cats}
    getOptionValue={(option) => btoa(option.id)}
    placeholder={props.placeHolder}
   // defaultValue={props.propSelected}
    styles={customStyles}
    isClearable
  />
  <input className={props.propClass} type="hidden" name={props.target_obj} id={props.target_obj} 
  value={selectedOption ? btoa(selectedOption.id) : ''}
  />
  {typeof  props.comp_sel_text!=="undefined"?<input className={props.propClass} type="hidden" name={props.comp_sel_text} id={props.comp_sel_text}
value={selectedOption?selectedOption.label:''}
 />:''}
  </>)
}else{
  return(<></>)
}

}




export default CompGetAdmins;